import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';

import { Button, Form } from 'react-bootstrap';
import GenericTable from 'componentes/generic/GenericTable.js';

const NomsTable = ({ noms, setIdNomEdit, setOpenModal }) => {
  const columns = [
    {
      accessorKey: 'clave',
      header: 'Clave',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'titulo',
      header: 'Titulo',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' },
      cell: ({ row }) => {
        return (
          <div>
            {row.original.titulo.length > 30
              ? row.original.titulo.substring(0, 27) + '...'
              : row.original.titulo}
          </div>
        );
      }
    },
    {
      accessorKey: 'esvigente',
      header: 'Es Vigente',
      headerProps: { style: { minWidth: '300px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' },
      cell: ({ row }) => {
        return (
          <div>
            <Form.Check checked={row.original.esvigente} />
          </div>
        );
      }
    },
    {
      accessorKey: 'idnom',
      header: '',
      disableSortBy: true,
      cellProps: {
        className: 'text-end'
      },
      cell: ({ row: { original } }) => {
        const { idnom } = original;

        return (
          <>
            <Button
              variant="falcon-default"
              size="sm"
              title="Editar"
              onClick={() => {
                setIdNomEdit(idnom);
                setOpenModal(true);
              }}
            >
              <FontAwesomeIcon icon="pencil-alt" />
            </Button>
            {/* <Button
                       variant="falcon-default"
                       size="sm"
                       title="Eliminar"
                       onClick={() => {
                         setIdMunicipioToDelete(idmunicipio);
                         setOpenConfirm(true);
                       }}
                     >
                       <FontAwesomeIcon icon="trash-alt" />
                     </Button> */}
          </>
        );
      }
    }
  ];
  return (
    <>
      <GenericTable
        data={noms}
        title="NOM's"
        columns={columns}
        addAction={() => {
          setIdNomEdit(0);
          setOpenModal(true);
        }}
      ></GenericTable>
    </>
  );
};
NomsTable.propTypes = {
  noms: PropTypes.array.isRequired,
  setIdNomEdit: PropTypes.func.isRequired,
  setOpenModal: PropTypes.func.isRequired
};
export default NomsTable;
